import React, { Component, Fragment } from 'react';
import { observer, inject } from 'mobx-react';
import { withRouter } from 'react-router-dom';

import { Button, Card, Table } from 'antd';

import moment from 'moment';
import TextPreview from './TextPreview';

import './UnreadNotifications.css';

import ToCarView from '../../../common/icons/CarIcon';

@withRouter
@inject('translationsStore', 'communicationsStore')
@observer
class UnreadNotifications extends Component {
  constructor(props) {
    super(props);
    const { communicationsStore } = this.props;
    this.state = {
      selectedRowKeys: [],
      unreadThreads: communicationsStore.unreadThreads,
      unreadMessages: communicationsStore.unreadMessages,
      paginationCurrent: 1
    };
  }

  onToCarViewClick = parameters => {
    let highlight;
    let isTicket;
    switch (parameters.type) {
      case 'client':
        // highlight = 'communication';
        highlight = 'CommunicationCard';
        break;
      case 'lead':
        // highlight = 'lead';
        highlight = 'LeadCard';
        break;
      case 'alarm':
        // highlight = 'alarm';
        highlight = 'AlarmsCard';
        break;
      case 'dtc':
        // highlight = 'dtc';
        highlight = 'DTCsCard';
        break;
      case 'ticket':
      case 'ticketCreated':
      case 'ticketFile':
      case 'ticketComment':
      case 'ticketUpdated':
      case 'ticketStatus':
      case 'ticketResolved':
        // highlight = 'ticket';
        isTicket = 'TicketCard';
        break;
      default:
        highlight = undefined;
        isTicket = undefined;
    }
    const { history, communicationsStore } = this.props;
    const { carId, notificationId } = parameters;
    communicationsStore.toggleVisiblePopover();
    if ('notificationId' in parameters) {
      communicationsStore.markReadByNotificationId(notificationId);
    }
    const found = ['carlist'].find(element => this.props.history.location.pathname.indexOf(`/${element}`) > -1);
    history.push(`/carview/${carId}${typeof found !== 'undefined' ? `?from=${found}` : ''}${typeof isTicket !== 'undefined' ? `${typeof found !== 'undefined' ? '&' : '?'}ticketId=${parameters.ticketId}` : ''}${typeof highlight !== 'undefined' ? `#${highlight}` : ''}`);
  };

  handleMarkCheckedAsRead = () => {
    const { communicationsStore } = this.props;
    const { selectedRowKeys } = this.state;
    let toBeMarked = [];
    selectedRowKeys.forEach(key => {
      const communication = communicationsStore.list[key];
      const { notificationId } = communication;
      if (notificationId !== undefined) {
        toBeMarked.push(notificationId);
      }
    });
    communicationsStore.markManyReadByNotificationIds(toBeMarked).then(response => {
      if ('success' in response && response.success === true) {
        this.setState({ selectedRowKeys: [], paginationCurrent: 1 });
      }
    });
  };

  render() {
    const { translationsStore, communicationsStore } = this.props;
    const { selectedRowKeys } = this.state;

    communicationsStore.storeRemoteNotified instanceof Function && communicationsStore.storeRemoteNotified();

    communicationsStore.storeRemoteNotified instanceof Function && communicationsStore.storeRemoteNotified();

    const columns = [
      {
        key: 'sender',
        dataIndex: 'sender',
        title: translationsStore.translate('header.unreadNotifications.columns.sender'),
        render: (text, record) => (
          <TextPreview width="150px">
            {record.sender === null ? <span className="senderIsPlatform">{translationsStore.translate('header.unreadNotifications.labelSenderPlatform')}</span> : record.sender}
          </TextPreview>
        )
      },
      {
        key: 'message',
        dataIndex: 'message',
        title: translationsStore.translate('header.unreadNotifications.columns.message'),
        render: (text, record) => {
          switch (record.type) {
            case 'lead':
              return <TextPreview width="240px">{translationsStore.translate('header.unreadNotifications.labelCreatedLead')}</TextPreview>;
            case 'dtc':
              return <TextPreview width="240px">{translationsStore.translate('header.unreadNotifications.labelCreatedDTC')}</TextPreview>;
            case 'alarm':
              return <TextPreview width="240px">{translationsStore.translate('header.unreadNotifications.labelCreatedAlarm')}</TextPreview>;
            case 'maintenance':
              return <TextPreview width="240px">{translationsStore.translate('header.unreadNotifications.labelCreatedMaintenance')}</TextPreview>;
            case 'crash':
              return <TextPreview width="240px">{translationsStore.translate('header.unreadNotifications.labelCreatedCrash')}</TextPreview>;
            case 'help-request':
              return <TextPreview width="240px">{translationsStore.translate('header.unreadNotifications.labelCreatedHelpRequest')}</TextPreview>;
            case 'ticket':
              return <TextPreview width="240px">{translationsStore.translate('header.unreadNotifications.labelCreatedTicket')}{record.ticketId}</TextPreview>;
            case 'ticketCreated':
            case 'ticketFile':
            case 'ticketComment':
            case 'ticketUpdated':
            case 'ticketStatus':
            case 'ticketResolved':
              return <TextPreview width="240px">{translationsStore.translate('header.unreadNotifications.' + record.type)}{record.ticketId}</TextPreview>;
            default:
              return <TextPreview width="240px">{record.message}</TextPreview>;
          }
        }
      },
      {
        key: 'plate',
        dataIndex: 'plate',
        title: translationsStore.translate('header.unreadNotifications.columns.plate'),
        width: '120px',
        className: 'PlatePreview',
        render: (text, record) => <div>{(record.car || {}).plate}</div>
      },
      {
        key: 'createdAt',
        dataIndex: 'createdAt',
        title: translationsStore.translate('header.unreadNotifications.columns.createdAt'),
        className: 'DatePreview',
        render: (text, record) => (
          <div>
            <div>{moment(`${record.createdAt}`).format('DD MMM')}</div>
            <div>
              {moment(`${record.createdAt}`).format('HH')}:{moment(`${record.createdAt}`).format('mm')}
            </div>
          </div>
        )
      },
      {
        dataIndex: '',
        width: '50px',
        className: '',
        render: (text, record) => (
          <div className="goToCarview" style={{ width: 50 }}>
            {record.carId !== undefined && (
              <ToCarView
                style={{ cursor: 'pointer', fontSize: '2.5rem' }}
                onClick={() => {
                  this.onToCarViewClick(record);
                }}
              />
            )}
          </div>
        )
      }
    ];

    const rowSelection = {
      onChange: (selectedRowKeys, selectedRows) => {
        this.setState({ selectedRowKeys });
      },
      selectedRowKeys: this.state.selectedRowKeys,
      onSelectAll: (selected, selectedRows, changeRows) => {
        const selectedRowKeys = selected ? Array.from(Array(communicationsStore.list.length).keys()) : [];
        this.setState({ selectedRowKeys });
      }
    };

    return (
      <Fragment>
        <Card bordered={false} style={{ backgroundColor: 'white' }}>
          <Button type="primary" disabled={selectedRowKeys.length === 0} className="" style={{ marginBottom: 20 }} onClick={this.handleMarkCheckedAsRead}>
            {`${translationsStore.translate('header.unreadNotifications.buttonMarkAsRead')}${selectedRowKeys.length > 0 ? ` (${selectedRowKeys.length})` : ''}`}
          </Button>
          <Table
            className="UnreadNotifications"
            pagination={{
              hideOnSinglePage: true,
              pageSize: 5,
              current: this.state.paginationCurrent,
              onChange: page => {
                this.setState({
                  paginationCurrent: page
                });
              }
            }}
            columns={columns}
            dataSource={communicationsStore.list}
            rowClassName="NotificationItem"
            onRow={record => {
              const rowClassName = ['NotificationItem'];
              // classe aggiuntiva per contrassegnare messaggi ancora da leggere, se lista presente contiene anche elementi già letti
              if (this.state.unreadThreads.includes(record.threadId)) {
                rowClassName.push('NotificationItemToBeRead');
              }
              return {
                className: rowClassName
              };
            }}
            rowSelection={rowSelection}
          />
        </Card>
      </Fragment>
    );
  }
}

export default UnreadNotifications;
